import useCancelTokenRequest from '@intelligence/hooks/useCancelTokenRequest';
import {
  getGlobalViewTabletDataWhenMobile as getGlobalViewTabletDataWhenMobileOriginal,
  getGlobalViewChartsDataWhenMobile as getGlobalViewChartsDataWhenMobileOriginal,
} from '@/pages/intelligence/services/globalView';

export default function useCancelableServices() {
  const { service: getGlobalViewTabletDataWhenMobile } = useCancelTokenRequest<any, any>(getGlobalViewTabletDataWhenMobileOriginal);
  const { service: getGlobalViewChartsDataWhenMobile } = useCancelTokenRequest<any, any>(getGlobalViewChartsDataWhenMobileOriginal);

  return {
    getGlobalViewTabletDataWhenMobile,
    getGlobalViewChartsDataWhenMobile,
  };
}
